<template>
  <v-dialog v-model="dialog" width="550">
    <template v-slot:activator="{ on, attrs }">
      <div v-on="on" v-bind="attrs">
        <v-btn
          v-if="$vuetify.breakpoint.mdAndUp"
          class="add-remove-button mr-4"
          outlined
          small
          fab
          color="secondary"
        >
          <span class="secondary--text">?</span>
        </v-btn>
        <!-- @click="openInfo" -->
        <span
          v-if="$vuetify.breakpoint.mdAndUp"
          class="seat-header-subtitle-text click-btn mr-12"
          >{{ $t("cart.subtitle") }}</span
        >
      </div>
    </template>

    <v-card>
      <v-card-title class="mb-4">
        <v-row justify="space-between" no-gutters>
          <span>{{ $t("cart.subtitle") }}</span>
          <v-icon @click="dialog = false">mdi-close</v-icon>
        </v-row>
      </v-card-title>

      <v-card-text>
        <div v-if="pricesSubtitle">
          <v-row
            no-gutters
            v-for="(seat, index) in pricesSubtitle"
            :key="index"
          >
            <div class="icon-img ml-2 mr-3 mb-4">
              <v-icon size="20" :color="seat.cor ? `${seat.cor}` : '#e0e0e0'"
                >mdi-circle</v-icon
              >
            </div>
            <span class="grey--text">{{ seat.price }}</span>
          </v-row>
        </div>
        <v-row no-gutters v-for="(option, index) in options" :key="index">
          <div class="icon-img ml-2 mr-3 mb-4">
            <v-img flat :src="option.icon"></v-img>
          </div>
          <span class="grey--text">{{ option.text }}</span>
        </v-row>
      </v-card-text>

      <v-card-title>
        <h3 class="checkout-h3">{{ $t("cart.specialSeats") }}</h3>
        <span class="checkout-h5 grey--text">{{ $t("cart.proof") }}</span>
      </v-card-title>
      <v-card-text>
        <v-row no-gutters>
          <div class="icon-img-pcd mr-4 mb-4">
            <v-img flat :src="pcdLarge.icon"></v-img>
          </div>
          <span class="grey--text">{{ pcdLarge.text }}</span>
        </v-row>
        <v-row no-gutters>
          <div class="icon-img ml-2 mr-4 mb-4">
            <v-img flat :src="pcdSmall.icon"></v-img>
          </div>
          <span class="grey--text ml-3">{{ pcdSmall.text }}</span>
        </v-row>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      options: [
        {
          icon: "https://blueticket-cdn.s3.amazonaws.com/assets/icons/unavaiable_seat.svg",
          text: "Indisponível",
        },
        {
          icon: "https://blueticket-cdn.s3.amazonaws.com/assets/icons/selected_seat.svg",
          text: "Selecionado",
        },
      ],
      pcdSmall: {
        icon: "https://blueticket-cdn.s3.amazonaws.com/assets/icons/pcd_small.svg",
        text: "Pessoas com Mobilidade Reduzida",
      },
      pcdLarge: {
        icon: "https://blueticket-cdn.s3.amazonaws.com/assets/icons/pcd_large.svg",
        text: "Portador de Cadeira de Rodas",
      },
      pricesSubtitle: null,
      dialog: false,
    };
  },
  mounted() {
    this.setPriceSubtitle();
  },
  computed: {
    ...mapGetters(["listSeats", "selectedSector"]),
  },
  methods: {
    setPriceSubtitle() {
      let array = [];
      this.listSeats.forEach((seat) => {
        if (
          seat.cor &&
          seat.produto_vinculado &&
          !array.find((a) => seat.cor == a.cor) &&
          seat.disponivel
        )
          array.push({
            cor: seat.cor,
            price: this.rangeByType(
              this.selectedSector.products.filter(
                (t) => seat.produto_vinculado === t.codigo_produto
              )
            ),
          });
      });
      this.pricesSubtitle = array;
    },
    closeInfo() {
      this.$store.commit("SET_SELECTED_INFO", false);
    },
    rangeByType(productTypes) {
      let min = Number.MAX_SAFE_INTEGER;
      let max = Number.MIN_SAFE_INTEGER;

      productTypes.forEach((type) => {
        if (!type.encerrado) {
          const value = type.valor + type.valor_conveniencia;
          if (min > value) {
            min = value;
          }

          if (max < value) {
            max = value;
          }
        }
      });

      if (max === Number.MIN_SAFE_INTEGER && min === Number.MAX_SAFE_INTEGER) {
        max = 0;
        min = 0;
        return "";
      }
      min = this.$options.filters.currency(min);
      max = this.$options.filters.currency(max);
      return min !== max
        ? `Disponível - De ${min} a ${max}`
        : `Disponível - ${min}`;
    },
  },
};
</script>

<style scoped>
.add-remove-button {
  height: 24px !important;
  width: 24px !important;
  margin: 0;
  border-width: 2px !important;
  justify-content: center;
}

.seat-header-subtitle-text {
  font-size: 14px;
  line-height: 18px;
  font-weight: 450;
  font-style: normal;
  align-items: center;
  color: #1976d2;
  vertical-align: middle;
}
</style>
